<div class="match-row-container text border-bottom" [ngClass]="{ 'match-row-container-selected': ('isRowSelected' | getEnv) && isMatchIdInCurrentSlipData(_d.BetradarMatchId) }">
  <div class="match-row-match-info">
    <div class="match-info-favorite-statistics">
      <div (click)="addMatch2Favs(_d)" [ngStyle]="{ opacity: this._UserHelper.isSignedIn ? 1 : 0 }">
        <!-- <image-loader-utils
          [extraClasses]="'star-icon ' + (this._DataHelper.favList.includes(_d.BetradarMatchId) ? 'star-icon-active' : 'star-icon-disabled')"
          url="star"></image-loader-utils> -->
        <ng-container *ngIf="!this._DataHelper.favList.includes(_d.BetradarMatchId); else favoritedTemplate">
          <image-loader-utils [url]="'favorite'" [isFlags]="true" extraClasses="favorited-left-menu" imageFormat="png"></image-loader-utils>
        </ng-container>
        <ng-template #favoritedTemplate>
          <image-loader-utils [url]="'favorited'" [isFlags]="true" extraClasses="favorited-left-menu" imageFormat="png"></image-loader-utils>
        </ng-template>
      </div>
    </div>
    <div class="match-info-date-time">
      <ng-container *ngIf="!_isLive">
        <div>
          {{ getWhich(_d.MatchDate) === 1 ? ('today' | translate) : getWhich(_d.MatchDate) === 2 ? (_d.MatchDate | dateFormat : 'E') : (_d.MatchDate | dateFormat : 'dd-MM') }}
        </div>
        <div>
          {{ _d.MatchTime }}
        </div>
      </ng-container>
      <ng-container *ngIf="_isLive">
        <ng-container *ngIf="_d.HasStreaming === 'live'">
          <ng-container *ngIf="_sportName === 'Soccer' || _sportName === 'Rugby' || _sportName === 'Handball' || _sportName === 'Futsal'">
            <ng-container *ngIf="_d.TimeStatu != 3 && _d.TimeStatu != 12 && _d.TimeStatu != 13 && _d.TimeStatu != 5">{{
              _d.MatchTimeExtended == null ? (_d.EventDate && _d.EventDate != NaN ? (_d.EventDate | dateFormat : 'h:mm a') : _d.MatchTimeExtended) : _d.MatchTimeExtended + "'"
            }}</ng-container>
            <ng-container *ngIf="_d.TimeStatu == 3 || _d.TimeStatu == 12 || _d.TimeStatu == 13 || _d.TimeStatu == 5">{{ _d.TimeStatuColor }}</ng-container>
          </ng-container>
          <ng-container
            *ngIf="_sportName === 'Basketball' || _sportName === 'Ice Hockey' || _sportName === 'Field Hockey' || _sportName === 'Aussie rules' || _sportName === 'Football'">
            <ng-container *ngIf="_d.TimeStatu != 3">
              <ng-container *ngIf="_d.TimeStatu != 29 && _d.TimeStatu != 31">{{ _d.TimeStatuColor }} </ng-container>
              <ng-container *ngIf="_d.TimeStatu != 29 && _d.TimeStatu != 31 && _d.TimeStatu != 33 && _d.TimeStatu != 35"
                >{{ _d.MatchTimeExtended == null ? '' : _d.MatchTimeExtended + "'" }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="_d.TimeStatu == 3">{{ _d.TimeStatuColor }}</ng-container>
          </ng-container>

          <!--Darts Live için bakılacak <ng-container *ngIf="_sportName == 'Tennis' || _sportName == 'Volleyball' || _sportName == 'Table tennis' || _sportName == 'Baseball' || _sportName == 'Snooker'|| _sportName == 'Darts'"> -->

          <ng-container
            *ngIf="
              _sportName === 'Tennis' ||
              _sportName === 'Volleyball' ||
              _sportName === 'Table tennis' ||
              _sportName === 'Baseball' ||
              _sportName === 'Snooker' ||
              _sportName === 'Aussie rules'
            ">
            {{ _d.TimeStatuColor }}
          </ng-container>

          <div class="time-statu-container live">
            {{ 'live' | translate }}
          </div>

          <ng-container *ngIf="('isLiveStream' | getEnv) && this._UiHelper.windowsWidth > 990 && this._LiveStreamService.videoUrlSearch(this._d)">
            <div
              class="live-stream-container"
              [ngClass]="this._LiveStreamService.matchRowSearchVideoUrl(_d.BetradarMatchId) ? 'live-isActived' : ''"
              (click)="this._LiveStreamService.setLiveStreamUrl(_d)">
              <image-loader-utils url="tv" extraClasses="live-stream-icon"></image-loader-utils>
            </div>
          </ng-container>
        </ng-container>

        <!-- Up Coming -->
        <ng-container *ngIf="_d.HasStreaming === 'pre'">
          {{ _d.TimeStatuColor }}
        </ng-container>
        <!-- Up Coming -->
      </ng-container>
    </div>
    <div class="match-info-date-time mobile">
      <ng-container *ngIf="!_isLive">
        <div>
          {{ getWhich(_d.MatchDate) === 1 ? ('today' | translate) : getWhich(_d.MatchDate) === 2 ? (_d.MatchDate | dateFormat : 'E') : (_d.MatchDate | dateFormat : 'dd-MM') }}
        </div>
        <div>
          {{ _d.MatchTime }}
        </div>
      </ng-container>
      <ng-container *ngIf="_isLive">
        <ng-container *ngIf="_sportName === 'Soccer' || _sportName === 'Rugby' || _sportName === 'Handball' || _sportName === 'Futsal'">
          <ng-container *ngIf="_d.TimeStatu != 3 && _d.TimeStatu != 12 && _d.TimeStatu != 13 && _d.TimeStatu != 5">{{
            _d.MatchTimeExtended == null ? (_d.EventDate && _d.EventDate != NaN ? (_d.EventDate | dateFormat : 'hh:mm a') : _d.MatchTimeExtended) : _d.MatchTimeExtended + "'"
          }}</ng-container>
          <ng-container *ngIf="_d.TimeStatu == 3 || _d.TimeStatu == 12 || _d.TimeStatu == 13 || _d.TimeStatu == 5">{{ _d.TimeStatuColor }}</ng-container>
        </ng-container>
        <ng-container *ngIf="_sportName === 'Basketball' || _sportName === 'Ice Hockey' || _sportName === 'Field Hockey' || _sportName === 'Football'">
          <ng-container *ngIf="_d.TimeStatu != 3">
            <ng-container *ngIf="_d.TimeStatu != 29 && _d.TimeStatu != 31"> {{ _d.TimeStatuColor }}<br /> </ng-container>
            <ng-container *ngIf="_d.TimeStatu != 29 && _d.TimeStatu != 31 && _d.TimeStatu != 33 && _d.TimeStatu != 35"
              >{{ _d.MatchTimeExtended == null ? '' : _d.MatchTimeExtended + "'" }}
            </ng-container>
          </ng-container>
          <ng-container *ngIf="_d.TimeStatu == 3 || _d.TimeStatu == 12 || _d.TimeStatu == 13 || _d.TimeStatu == 5">{{ _d.TimeStatuColor }}</ng-container>

          <!--<ng-container *ngIf="_d.TimeStatu == 3">{{_d.TimeStatuColor}}</ng-container>-->
        </ng-container>
        <ng-container
          *ngIf="
            _sportName === 'Tennis' ||
            _sportName === 'Volleyball' ||
            _sportName === 'Table tennis' ||
            _sportName === 'Baseball' ||
            _sportName === 'Darts' ||
            _sportName === 'Snooker'
          ">
          {{ _d.TimeStatuColor }}
        </ng-container>
        <div class="time-statu-container live">
          {{ 'live' | translate }}
        </div>
      </ng-container>
    </div>
    <!-- Mobile -->

    <div class="match-info-teams" (click)="goEventDetail2(_d.MatchId, _d.EventId, _d)">
      <div class="flex">
        <ng-container *ngIf="_sportName === 'Soccer' && ('teamImageAssetsUrl' | getEnv) !== ''">
          <team-uniform-utils [extraClass]="'match-row-uniform'" [teamId]="_d.HomeTeamId"></team-uniform-utils>
        </ng-container>

        {{ _d.HomeTeam }}
        <div class="{{ _d.RedCardHomeTeam != 0 && _d.RedCardHomeTeam != undefined ? 'red-card-2' : null }}" *ngIf="_d.RedCardHomeTeam != 0 && _d.RedCardHomeTeam != undefined">
          {{ _d.RedCardHomeTeam }}
        </div>
        <ng-container *ngIf="_sportName === 'Tennis' || _sportName === 'Table tennis'">
          <span class="matchServer" *ngIf="_d.MatchServer == 1"></span>
        </ng-container>
      </div>
      <div class="flex">
        <ng-container *ngIf="_sportName === 'Soccer' && ('teamImageAssetsUrl' | getEnv) !== ''">
          <team-uniform-utils [extraClass]="'match-row-uniform'" [teamId]="_d.AwayTeamId"></team-uniform-utils>
        </ng-container>

        {{ _d.AwayTeam }}
        <div class="{{ _d.RedCardAwayTeam != 0 && _d.RedCardAwayTeam != undefined ? 'red-card-2' : null }}" *ngIf="_d.RedCardAwayTeam != 0 && _d.RedCardAwayTeam != undefined">
          {{ _d.RedCardAwayTeam }}
        </div>
        <ng-container *ngIf="_sportName === 'Tennis' || _sportName === 'Table tennis'">
          <span class="matchServer" *ngIf="_d.MatchServer == 2"></span>
        </ng-container>
      </div>
    </div>

    <div class="match-row-score-board" *ngIf="_isLive && _d.Score?.split(':')[0] !== '-' && _d.Score?.split(':')[1] !== '-'">
      <ng-container *ngIf="_sportName === 'Soccer'">
        <div class="score-board-box now">
          <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">{{ _d.Score?.split(':')[0] }}</span>
          <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">{{ _d.Score?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.GameScore?.split(':')[0] !== '-'">
          <span *ngIf="_d.GameScore?.split(':')[0] !== '-'">{{ _d.GameScore?.split(':')[0] }}&nbsp;</span>
          <span *ngIf="_d.GameScore?.split(':')[1] !== '-'">{{ _d.GameScore?.split(':')[1] }}&nbsp;</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Table tennis'">
        <div class="score-board-box now">
          <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">{{ _d.Score?.split(':')[0] }}</span>
          <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">{{ _d.Score?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('1') && _d.GameScore?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore?.split(':')[0] }}</span>
          <span>{{ _d.GameScore?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('2') && _d.GameScore2?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore2?.split(':')[0] }}</span>
          <span>{{ _d.GameScore2?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('3') && _d.GameScore3?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore3?.split(':')[0] }}</span>
          <span>{{ _d.GameScore3?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('4') && _d.GameScore4?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore4?.split(':')[0] }}</span>
          <span>{{ _d.GameScore4?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('5') && _d.GameScore5?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore5?.split(':')[0] }}</span>
          <span>{{ _d.GameScore5?.split(':')[1] }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Handball' || _sportName === 'Futsal'">
        <div class="score-board-box now">
          <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">{{ _d.Score?.split(':')[0] }}</span>
          <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">{{ _d.Score?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.GameScore?.split(':')[0] !== '-'">
          <span *ngIf="_d.GameScore?.split(':')[0] !== '-'">{{ _d.GameScore?.split(':')[0] }}&nbsp;</span>
          <span *ngIf="_d.GameScore?.split(':')[1] !== '-'">{{ _d.GameScore?.split(':')[1] }}&nbsp;</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Rugby' || _sportName === 'Baseball' || _sportName === 'Snooker'">
        <div class="score-board-box now">
          <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">{{ _d.Score?.split(':')[0] }}</span>
          <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">{{ _d.Score?.split(':')[1] }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Basketball' || _sportName === 'Aussie rules'">
        <div class="score-board-box now basketball">
          <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">
            {{ _d.Score?.split(':')[0] }}
          </span>
          <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">
            {{ _d.Score?.split(':')[1] }}
          </span>
        </div>
        <div class="score-board-box" *ngIf="_d.GameScore?.split(':')[0] !== '-'">
          <span *ngIf="_d.GameScore?.split(':')[0] !== '-'">{{ _d.GameScore?.split(':')[0] }}&nbsp;</span>
          <span *ngIf="_d.GameScore?.split(':')[1] !== '-'">{{ _d.GameScore?.split(':')[1] }}&nbsp;</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Ice Hockey' || _sportName === 'Field Hockey'">
        <div class="score-board-box now">
          <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">{{ _d.Score?.split(':')[0] }}</span>
          <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">{{ _d.Score?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.GameScore?.split(':')[0] !== '-'">
          <span *ngIf="_d.GameScore?.split(':')[0] !== '-'">{{ _d.GameScore?.split(':')[0] }})&nbsp;</span>
          <span *ngIf="_d.GameScore?.split(':')[1] !== '-'">{{ _d.GameScore?.split(':')[1] }}&nbsp;</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Tennis' || _sportName === 'Darts'">
        <div class="score-board-box now">
          <span>{{ _d.Score?.split(':')[0] }}</span>
          <span>{{ _d.Score?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('1') && _d.GameScore?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore?.split(':')[0] }}</span>
          <span>{{ _d.GameScore?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('2') && _d.GameScore2?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore2?.split(':')[0] }}</span>
          <span>{{ _d.GameScore2?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('3') && _d.GameScore3?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore3?.split(':')[0] }}</span>
          <span>{{ _d.GameScore3?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box">
          <span>{{ _d.LegScoreHome }}</span>
          <span>{{ _d.LegScoreAway }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="_sportName === 'Volleyball'">
        <div class="score-board-box now">
          <span>{{ _d.Score?.split(':')[0] }}</span>
          <span>{{ _d.Score?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('1') && _d.GameScore?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore?.split(':')[0] }}</span>
          <span>{{ _d.GameScore?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('2') && _d.GameScore2?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore2?.split(':')[0] }}</span>
          <span>{{ _d.GameScore2?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('3') && _d.GameScore3?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore3?.split(':')[0] }}</span>
          <span>{{ _d.GameScore3?.split(':')[1] }}</span>
        </div>
        <div class="score-board-box" *ngIf="_d.TimeStatuColor.includes('4') && _d.GameScore4?.split(':')[0] !== '-'">
          <span>{{ _d.GameScore4?.split(':')[0] }}</span>
          <span>{{ _d.GameScore4?.split(':')[1] }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="_sportName === 'Football'">
        <div class="score-board-box now basketball">
          <ng-container *ngFor="let scorePart of splitAndCheckScore(_d.Score); let i = index">
            <span class="{{ i === 0 ? _d.homegoalcss : _d.awaygoalcss }}" *ngIf="scorePart !== null">
              {{ scorePart }}
            </span>
          </ng-container>
        </div>
        <div class="score-board-box" *ngIf="splitAndCheckScore(_d.GameScore)[0] !== null">
          <ng-container *ngFor="let gameScorePart of splitAndCheckScore(_d.GameScore)">
            <span *ngIf="gameScorePart !== null">{{ gameScorePart }}&nbsp;</span>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div (click)="openDialogStandings(_d)" style="margin-right: 10px">
      <image-loader-utils url="mini-istatistic" extraClasses="signal-icon"></image-loader-utils>
    </div>
    <div class="match-info-favorite-statistics mobile">
      <div (click)="addMatch2Favs(_d)" [ngStyle]="{ opacity: this._UserHelper.isSignedIn ? 1 : 0 }">
        <ng-container *ngIf="!this._DataHelper.favList.includes(_d.BetradarMatchId); else favoritedTemplate">
          <image-loader-utils [url]="'favorite'" [isFlags]="true" extraClasses="favorited-left-menu" imageFormat="png"></image-loader-utils>
        </ng-container>
        <ng-template #favoritedTemplate>
          <image-loader-utils [url]="'favorited'" [isFlags]="true" extraClasses="favorited-left-menu" imageFormat="png"></image-loader-utils>
        </ng-template>
      </div>
    </div>
  </div>
  <betStopReason-component
    [betStopReasonId]="_d.BetStopReasonId"
    [teamScore]="{ homeTeamScore: _d.HomeScore, awayTeamScore: _d.AwayScore }"
    [homeTeamName]="_d.HomeTeam"
    [awayTeamName]="_d.AwayTeam"
    [isLive]="this._isLive"
    page="matchRow">
    <div class="match-row-odds text">
      <ng-container *ngFor="let _y of oddTypeArray; let indexItem = index">
        <ng-container *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(indexItem)">
          <ng-container *ngIf="!mLine[_y]">
            <div class="odds-box">
              <ng-container *ngFor="let a of oddDatas[_y]">
                <div
                  *ngIf="_d['OddValue' + a.type] != null && _d['OddValue' + a.type + 'Visibility'] !== 'hidden' && _d['OddValue' + a.type] !== ''"
                  class="odd {{ checkOddId(_d['OddId' + a.type]) }}"
                  (click)="clickNewOdd(_d, a)">
                  <div class="odd-text-container">
                    <span class="odd-text" *ngIf="!a.preTextT">{{ a.preText }}</span>
                    <span class="odd-text" *ngIf="a.preTextT">{{ a.preTextT | translate }}</span>
                  </div>

                  <span class="odd-value">{{ _d['OddValue' + a.type] | oddFormat }}</span>
                  <!-- downarrow - uparrow animation -->
                  <div class="{{ _d['OddValue' + a.type + 'css'] }}"></div>
                  <!-- downarrow - uparrow animation -->
                </div>
                <div class="odd" *ngIf="_d['OddValue' + a.type] == null || _d['OddValue' + a.type + 'Visibility'] === 'hidden' || _d['OddValue' + a.type] === ''">
                  <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                </div>
              </ng-container>
            </div>
            <div class="more-container" (click)="goEventDetail2(_d.MatchId, _d.EventId, _d)">
              <span class="oddType-count">{{ _d.OddTypeCount }}</span>
              <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>
            </div>
          </ng-container>

          <ng-container *ngIf="mLine[_y]">
            <div class="multiline" style="display: flex; flex-direction: column; width: 100%">
              <!-- _y => 1 Handicap ( HC ) -->
              <!-- _y => 2 Over/Under ( OU ) -->
              <!-- _y => 7 Over/Under 1.Ht ( OU ) -->

              <ng-container *ngFor="let oddRow of oddDatas[_y]; let rowIndex = index">
                <div
                  class="odds-box"
                  *ngIf="
                    (oddRow &&
                      oddRow &&
                      oddRow[0] &&
                      _d['OddValue' + oddRow[0].type] != null &&
                      _d['OddValue' + oddRow[0].type + 'Visibility'] !== 'hidden' &&
                      _d['OddValue' + oddRow[0].type] !== '') ||
                    rowIndex === 0
                  ">
                  <ng-container *ngFor="let a of oddRow | slice : 0 : 3; let indexItem = index">
                    <div
                      class="odd special"
                      [ngClass]="{
                        empty: !(_d['OddSpecialBetValue' + a.lineText] && _d['OddSpecialBetValue' + a.lineText] !== null && _d['OddSpecialBetValue' + a.lineText] !== ' ')
                      }"
                      *ngIf="(_y == 1 || _y == 2 || _y == 7 || _y == 10 || _y == 14 || _y == 16 || _y == 17 || _y == 18 || _y == 20 || _y == 22 || _y == 26) && indexItem == 0">
                      <!-- <span class="odd-text">
                        <ng-container *ngIf="_y == 1 || _y == 22 || _y == 26">
                          {{ 'hc' | translate }}
                        </ng-container>
                        <ng-container *ngIf="_y == 2 || _y == 7 || _y == 14">
                          {{ 'Goals' | translate }}
                        </ng-container>
                        <ng-container *ngIf="_y == 18 || _y == 20">
                          {{ 'TennisSet_Long' | translate }}
                        </ng-container>
                        <ng-container *ngIf="_y == 10 && _sportName !== 'Tennis' && _sportName !== 'Volleyball' && _sportName !== 'Basketball' && _sportName !== 'Table tennis'">
                          {{ 'Goals' | translate }}
                        </ng-container>
                        <ng-container
                          *ngIf="
                            (_y == 10 || _y == 16 || _y == 17) &&
                            (_sportName === 'Tennis' || _sportName === 'Volleyball' || _sportName === 'Basketball' || _sportName === 'Table tennis')
                          ">
                          {{ 'Point_Long' | translate }}
                        </ng-container>
                      </span> -->
                      <span class="odd-value">{{ _d['OddSpecialBetValue' + a.lineText] }}</span>
                      <div></div>
                    </div>

                    <div
                      *ngIf="_d['OddValue' + a.type] != null && _d['OddValue' + a.type + 'Visibility'] !== 'hidden' && _d['OddValue' + a.type] !== 0.0"
                      class="odd {{ checkOddId(_d['OddId' + a.type]) }}"
                      (click)="clickNewOdd(_d, a)">
                      <!-- <span class="odd-text" *ngIf="!a.preTextT">{{ a.preText }}</span>
                      <span class="odd-text" *ngIf="a.preTextT">{{ a.preTextT | translate }}</span> -->
                      <span class="odd-value">{{ _d['OddValue' + a.type] | oddFormat }}</span>
                      <!-- downarrow - uparrow animation -->
                      <div class="{{ _d['OddValue' + a.type + 'css'] }}"></div>
                      <!-- downarrow - uparrow animation -->
                    </div>

                    <div class="odd lock" *ngIf="_d['OddValue' + a.type] == null || _d['OddValue' + a.type + 'Visibility'] === 'hidden' || _d['OddValue' + a.type] === 0.0">
                      <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                    </div>
                    <!-- Over Under da 2li oran arasına Special yazıyor-->
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </betStopReason-component>

  <div class="match-row-details" (click)="OpenDetails(_d.MatchId == null ? _d.EventId : _d.MatchId)">
    <span class="oddType-count">{{ _d.OddTypeCount }}</span>
    <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>
  </div>
</div>

<!-- EVENT DETAILS -->
<ng-container *ngIf="betId == _d.BetradarMatchId">
  <ng-container *ngIf="!_isLive">
    <div class="live-single-content">
      <eventdetail-component [showScoreBoard]="false" [eventIdByInput]="_d.MatchId == null ? _d.EventId : _d.MatchId"></eventdetail-component>
    </div>
  </ng-container>
</ng-container>
<!-- EVENT DETAILS -->
